module.exports = __webpack_public_path__ + "img/symbol-15-center.d9d45189.png";